const EPISODE_EDITOR_REGEX = /^\/dashboard\/episode\/([^/]+\/edit)?$/;
const EPISODE_OPTIONS_REGEX = /^\/dashboard\/episode\/([^/]+\/metadata\/edit)?$/;

export const getShowNewEpisodeButton = (
  currentPath: string,
  showQuickUploadDropdown: boolean
) => {
  // never show new episode button if the user is creating a new episode on the episode builder
  if (currentPath === '/dashboard/episode/new') {
    return false;
  }

  // don't show new episode button when editing existing episode in the episode builder
  if (currentPath.match(EPISODE_EDITOR_REGEX)) {
    return false;
  }

  // if the user is on the episode options page
  if (currentPath.match(EPISODE_OPTIONS_REGEX)) {
    // if the quick upload is enabled, do not show button, if disabled, show button
    return !showQuickUploadDropdown;
  }

  // otherwise, show button
  return true;
};
